import { BookCoverIcon } from '@/icons';
import { FilterDropdown } from './FilterDropdown';
interface SubjectFilterProps {
  value: string | null;
  onChange: (value: string) => void;
  options: Array<{
    value: string;
    label: string;
  }>;
  disabled?: boolean;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}

/**
 * 과목 필터 드롭다운 컴포넌트
 * 선택된 학년에 따라 동적으로 과목 옵션 표시
 */
export const SubjectFilter = ({
  value,
  onChange,
  options,
  disabled = false,
  open,
  onOpenChange
}: SubjectFilterProps) => {
  const defaultLabel = options[0]?.label ?? '';
  const label = options.find(o => o.value === value)?.label ?? defaultLabel;
  const hasValue = value !== null && value !== options[0]?.value;
  const filterOptions = options.map(option => ({
    key: option.value,
    label: option.label,
    isSelected: option.value === value,
    onSelect: () => onChange(option.value)
  }));
  return <FilterDropdown label={label} hasValue={hasValue} icon={<BookCoverIcon size="xs" />} options={filterOptions} onClear={() => onChange(options[0]?.value ?? 'all')} disabled={disabled} open={open} onOpenChange={onOpenChange} data-sentry-element="FilterDropdown" data-sentry-component="SubjectFilter" data-sentry-source-file="SubjectFilter.tsx" />;
};